import { useAuth, useIsReadOnly } from "@/core/auth/hooks";
import { Eye } from "lucide-react";
import { Trans, useTranslation } from "react-i18next";

export const ReadOnlyBanner = () => {
  const { organization } = useAuth();
  const isReadOnly = useIsReadOnly();
  const { t } = useTranslation("layout");

  if (!isReadOnly) {
    return null;
  }

  return (
    <div className="flex items-center justify-center gap-2 bg-amber-100 px-4 py-1.5 text-sm text-amber-900">
      <Eye className="size-4" />
      <span>
        <Trans
          t={t}
          i18nKey="readOnlyBanner"
          values={{ name: organization?.name }}
          components={{ strong: <span className="font-medium" /> }}
        />
      </span>
    </div>
  );
};
